import styled from "styled-components";

export const StyledPageTitle = styled.h1`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 24px;
  color: rgb(255, 255, 255);
  text-transform: uppercase;
  word-break: break-word;
  gap: 12px;
  font-size: 22px;
  font-weight: 900;

  svg {
    width: 18px;
    height: 18px;
  }
`;
